import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRecipientList } from "../../../../services/Recipients";
import {
  updateEnvelopeRecipientStep,
  envelopeFinish,
  modifyEnvelopeDocument,
} from "../../../../services/CommonService";
import Utils from "../../../../utils";
import EnvelopeRecipients from "./Recipients";
import { Lang } from "../../../../lang";
import Select from 'react-select';

function EnvelopeStep2(props) {
  const navigate = useNavigate();

  const [docData, setDocData] = useState({
    id: 0,
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    country_id: 227,
    company_name: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    address_country_id: "",
    zip_code: "",
  });

  const buttonRef = useRef(null);

  const [searchRecipientList, setSearchRecipientList] = useState([]);
  const [recipientSearch, setRecipientSearch] = useState("");
  const [subject, setSubject] = useState("");
  const [emailText, setEmailText] = useState("");

  let errorsObj = {
    recipient: "",
    subject: "",
    email_text: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [isAddTemplate, setIsAddTemplate] = useState(false);
  const [successData, setSuccessData] = useState(null);

  useEffect(function () {
    setSubject((props.formObj.subject) ? props.formObj.subject : '');
    setEmailText((props.formObj.email_text) ? props.formObj.email_text : '');
  }, [props]);

  function onBack(e) {
    e.preventDefault();
    const formData = { ...props.formObj };
    formData.current_step = 1;
    props.setFormObj(formData);
    navigate('/client-portal/sleeve/edit/' + formData.envelope_uuid + '/1');
  }

  function onRemoveRecipient(e, index) {
    e.preventDefault();
    const formData = { ...props.formObj };
    formData.recipient_List.splice(index, 1);
    props.setFormObj(formData);
  }

  const handleRecipientInputChange = (inputValue) => {
    setRecipientSearch(inputValue);
    getRecipientList({ search: inputValue, limit: 50, page: 1 })
      .then((response) => {
        setSearchRecipientList(response.data?.data || []);
      })
      .catch(() => setSearchRecipientList([]));
  };

  const handleRecipientInputFocus = () => {
    if (recipientSearch === "" && searchRecipientList.length === 0) {
      getRecipientList({ search: "", limit: 50, page: 1 })
        .then((response) => {
          setSearchRecipientList(response.data?.data || []);
        })
        .catch(() => setSearchRecipientList([]));
    }
  };

  const handleSearchRecipient = (e, obj) => {
    e.preventDefault();
    const formData = { ...props.formObj };
    let index = formData.recipient_List.findIndex((x) => x.email === obj.email);
    if (index === -1) {
      formData.recipient_List.push(obj);
      props.setFormObj(formData);
      setRecipientSearch("");
    } else {
      toast.error("Recipient already exist.");
    }
    setSearchRecipientList([]);
  };

  const displayedRecipients = recipientSearch.trim()
    ? props.formObj.recipient_List.filter(
      r =>
        (r.first_name + ' ' + r.last_name).toLowerCase().includes(recipientSearch.toLowerCase()) ||
        r.email.toLowerCase().includes(recipientSearch.toLowerCase()) ||
        (r.mobile && r.mobile.toLowerCase().includes(recipientSearch.toLowerCase()))
    )
    : props.formObj.recipient_List;

  function onSaveExit(e) {
    e.preventDefault();
    onSubmitForm(1);
  }

  function onNext(e) {
    e.preventDefault();
    onSubmitForm(2);
  }

  function onSubmitForm(type) {
    let error = false;
    const errorObj = { ...errorsObj };
    const formData = { ...props.formObj };

    if (formData.recipient_List.length === 0) {
      errorObj.recipient = "Please add recipient";
      error = true;
      toast.error("Please add recipient");
    }
    if (!subject) {
      errorObj.subject = "Subject must be required";
      error = true;
    }
    if (!emailText) {
      errorObj.email_text = "Email text must be required";
      error = true;
    }

    setErrors(errorObj);

    if (error) return;

    props.setLoading(true);

    let recipientIds = "";
    for (let i = 0; i < formData.recipient_List.length; i++) {
      recipientIds += formData.recipient_List[i]["id"];
      if (formData.recipient_List.length !== i + 1) {
        recipientIds += ",";
      }
    }

    let obj = {
      envelope_id: formData.envelope_id,
      recipient_ids: recipientIds,
      email_subject: subject,
      email_text: emailText,
    };

    updateEnvelopeRecipientStep(obj)
      .then((response) => {
        if (type === 2) {
          formData.current_step = 3;
          formData.subject = subject;
          formData.email_text = emailText;
          props.setFormObj(formData);
          navigate('/client-portal/sleeve/edit/' + formData.envelope_uuid + '/3');
        } else {
          navigate("/manage/draft");
        }
        toast.success(response.data.message);
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  }

  function onEditRecipient(e, obj) {
    e.preventDefault();
    let formData = { ...docData };
    formData.id = obj.id;
    formData.first_name = obj.first_name;
    formData.last_name = obj.last_name;
    formData.email = obj.email;
    formData.mobile = obj.mobile;
    formData.country_id = obj.country_id;
    formData.company_name = obj.company_name ? obj.company_name : "";
    formData.address_1 = obj.address_1 ? obj.address_1 : "";
    formData.address_2 = obj.address_2 ? obj.address_2 : "";
    formData.city = obj.city ? obj.city : "";
    formData.state = obj.state ? obj.state : "";
    formData.zip_code = obj.zip_code ? obj.zip_code : "";
    formData.address_country_id = obj.address_country_id ? obj.address_country_id : "";
    setDocData(formData);
    buttonRef.current?.click();
  }

  const handleEnvInput = (e, type) => {

    let envelopeData = { ...props.formObj };

    if (type === 'subject') {
      setSubject(e.target.value);
      envelopeData.subject = e.target.value;
    } else if (type === 'email_text') {
      setEmailText(e.target.value);
      envelopeData.email_text = e.target.value;
    }

    props.setFormObj(envelopeData);
  };

  const handleSearchOverlay = (e) => {
    e.preventDefault();
    setSearchRecipientList([]);
  };


  const onViewEnvelope = (e) => {
    e?.preventDefault && e.preventDefault();
    const envelopeFormData = { ...props.formObj };
    navigate('/manage/' + envelopeFormData.envelope_uuid);
  };

  const handleSendSleeves = async (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errors };
    const envelopeFormData = { ...props.formObj };
    if (envelopeFormData.recipient_List.length === 0) {
      errorObj.recipient = "Please add recipient";
      error = true;
      toast.error("Please add recipient");
    }
    if (!subject) {
      errorObj.subject = "Subject must be required";
      error = true;
    }
    if (!emailText) {
      errorObj.email_text = "Email text must be required";
      error = true;
    }
    setErrors(errorObj);
    if (error) return;

    const recipientIds = envelopeFormData.recipient_List.map(r => r.id).join(",");

    const docPayload = {
      envelope_id: String(envelopeFormData.envelope_id),
      doc_id: 0,
      request_form: recipientIds,
      name: envelopeFormData.envelope_name,
      detail: '',
      date_format: 0
    };

    props.setLoading(true);
    try {
      await modifyEnvelopeDocument(docPayload);
      let payload = { ...envelopeFormData };
      payload.recipient_ids = recipientIds;
      payload.subject = subject;
      payload.email_text = emailText;
      payload.recipient_List = envelopeFormData.recipient_List;
      let ipAddress = '';
      try {
        ipAddress = await Utils.getIpAddress();
      } catch (e) { }
      const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
      payload.time_zone = timeZone || '';
      payload.ip_address = ipAddress;
      payload.submit_type = 2;

      const response = await envelopeFinish(payload);
      toast.success("Your Sleeve has been Successfully Sent!");
      props.setLoading(false);
      navigate(`/client-portal/sleeve/sent/${props.formObj.envelope_uuid}`, {
        state: {
          link: response.data.link,
          otp: response.data.otp,
          recipient: response.data.recipient,
          sender: response.data.sender,
          due_date: response.data.due_date
        },
        replace: true
      });
      return;
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
      props.setLoading(false);
    }
  };

  const recipientOptions = searchRecipientList.map(item => ({
    value: item.email,
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    data: item,
  }));

  const formatRecipientOption = (option) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "8px 12px",
        borderRadius: 8,
        minWidth: 0,
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <div className="recipient-serach-avatar"

      >
        {option.data.first_name?.[0]?.toUpperCase() || ""}
      </div>
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontWeight: 600,
            fontSize: 16,
            color: "#222",
            height: "auto",
            maxWidth: 180,
          }}
        >
          {option.data.first_name + " " + option.data.last_name}
        </div>
        <div className="recipient-email-mobile-container">
          <div className="recipient-email">{option.data.email}</div>
          {option.data.mobile && (
            <div className="recipient-mobile-under-email">
              {Utils.mobileFormat(option.data)}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const handleSelectRecipient = (option) => {
    if (!option) return;
    const obj = option.data;
    const formData = { ...props.formObj };
    let index = formData.recipient_List.findIndex((x) => x.email === obj.email);
    if (index === -1) {
      formData.recipient_List.push(obj);
      props.setFormObj(formData);
      setRecipientSearch("");
    } else {
      toast.error("Recipient already exist.");
    }
    setSearchRecipientList([]);
  };

  useEffect(() => {
    if (window.bootstrap && window.bootstrap.Tooltip) {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        if (tooltipTriggerEl._tooltipInstance) {
          tooltipTriggerEl._tooltipInstance.dispose();
        }
        tooltipTriggerEl._tooltipInstance = new window.bootstrap.Tooltip(tooltipTriggerEl, { trigger: 'hover focus click' });
      });
    }
  }, []);

  const handleCopyLink = (e) => {
    e.preventDefault();
    if (successData && successData.link) {
      const recipient = successData.recipient || {};
      const sender = successData.sender || {};
      const formattedData = `Dear ${recipient.name || ''},\nI hope you are doing well.\n\nPlease upload the required documents by visiting the following link:\n🔗 ${successData.link}\n\nYou will need to enter the following access code to proceed:\n🔐 Access Code: ${successData.otp || ''}\n\nKindly complete this request before ${successData.due_date || ''}\nIf you have any questions or face any issues, feel free to reach out.\n\nBest regards,\n${sender.name || ''}\n${sender.company || ''}\n📞 ${sender.mobile_number || ''}\n✉️ ${sender.email || ''}`.trim();
      navigator.clipboard.writeText(formattedData)
        .then(() => {
          toast.success("Link copied to clipboard!");
        })
        .catch((err) => {
          toast.error("Failed to copy link.");
        });
    } else {
      toast.error("No link available to copy.");
    }
  };

  useEffect(() => {
    const handlePopState = () => {
      navigate('/client-portal', { replace: true });
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  return (
    <>
      {props.formObj.is_smart_sleeve ? (
        <div className="sleeve-gradient-bg">
          <div className="sleeve-main-card">
            <h1 className="sleeve-title">Smart Sleeve ✨</h1>
            <p className="sleeve-subtitle">Let AI organize everything for you automatically</p>
            {/* Recipient Details Card */}
            <div className="recipient-details-card-custom mb-4">
              <div className="recipient-details-card-custom-add">
                <div className="">
                  <i className="bi bi-people me-2 fs-4" />
                  <span className="fw-bold fs-5 sleeve-title-color">Recipient Details *</span>
                  <i className="bi bi-info-circle ms-1 cur-pointer fs-5" aria-hidden="true" data-toggle="tooltip"
                    data-placement="left" title={"Add Recipient(s)\n\nEnter one or more email addresses of people from whom you need documents. Each will receive a personal link."} />
                </div>
                <div className="align-items-center gap-2">
                  <button
                    type="button"
                    className="step2-add-btn ms-auto"
                    data-bs-toggle="offcanvas"
                    ref={buttonRef}
                    data-bs-target="#addRecipients"
                    aria-controls="addRecipients"
                    data-toggle="tooltip"
                    title={Lang.env_add_recipient}
                  >
                    <span className="me-2">+</span>Add Recipients
                  </button>
                </div>
              </div>
              <div className="mb-3">
                <Select
                  classNamePrefix="sleeve-sender-select"
                  value={null}
                  inputValue={recipientSearch}
                  onInputChange={handleRecipientInputChange}
                  onFocus={handleRecipientInputFocus}
                  onChange={handleSelectRecipient}
                  options={recipientOptions}
                  placeholder="Search recipients..."
                  isClearable
                  isSearchable
                  formatOptionLabel={formatRecipientOption}
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: 8,
                      minHeight: 48,
                      borderColor: errors.recipient ? '#dc3545' : '#e3e8f0',
                      boxShadow: 'none',
                      background: '#fff'
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isFocused ? '#f3f4f6' : '#fff',
                      color: '#222',
                      cursor: 'pointer'
                    }),
                    menu: (base) => ({ ...base, zIndex: 99 }),
                    input: (base) => ({ ...base, fontSize: '1rem' }),
                  }}
                />
                {errors.recipient && (
                  <div className="text-danger mt-2">{errors.recipient}</div>
                )}
              </div>
              {/* Recipient List or Empty State */}
              {displayedRecipients.length === 0 ? (
                <div className="step2-empty-state">
                  <div className="icon"><i className="bi bi-people" /></div>
                  <div>No recipients added yet</div>
                  <div style={{ fontSize: '13px' }}>Click "Add Recipients" to get started</div>
                </div>
              ) : (
                <div className="gap-3 w-100">
                  {displayedRecipients.map((item, index) => (
                    <div className="recipient-list-item-custom d-flex align-items-center justify-content-between bg-white rounded-3 px-4 py-3 shadow-sm" key={index}>
                      <div className="d-flex align-items-center gap-3">
                        <div className="avatar-circle-custom">{item.first_name?.[0]?.toUpperCase() || ''}</div>
                        <div>
                          <div className="fw-bold recipient-name">{item.first_name + ' ' + item.last_name}</div>
                          <div className="recipient-email-mobile">
                            <span className="text-muted">{item.email}</span>
                            <span className="text-muted recipient-mobile">{Utils.mobileFormat(item)}</span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span className="text-primary fs-5 cursor-pointer" onClick={(e) => onEditRecipient(e, item)}>
                          <i className="bi bi-pencil-square" />
                        </span>
                        <span className="text-danger fs-5 cursor-pointer" onClick={(e) => onRemoveRecipient(e, index)}>
                          <i className="bi bi-x-lg" />
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Email Details Card */}
            <div className="step2-card step2-card-email sleeve-sender-card  ">
              <div className="step2-section-title">
                <i className="bi bi-envelope-check" />
                Email Details
              </div>
              <div className="mb-3">
                <label className="sleeve-step-label">Subject</label>
                <input
                  type="text"
                  className="sleeve-step-input"
                  value={subject}
                  onChange={e => handleEnvInput(e, 'subject')}
                  placeholder="Enter Email Subject"
                />
                {errors.subject && (
                  <div className="text-danger mt-1">{errors.subject}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="sleeve-step-labe">Email Text</label>
                <textarea
                  className="sleeve-step-textarea"
                  rows={8}
                  value={emailText}
                  onChange={e => handleEnvInput(e, 'email_text')}
                  placeholder="Enter Email text box"
                />
                {errors.email_text && (
                  <div className="text-danger mt-1">{errors.email_text}</div>
                )}
              </div>
            </div>
            {/* Recipient Add/Edit Offcanvas */}
            <EnvelopeRecipients formObj={props.formObj} setFormObj={props.setFormObj} setLoading={props.setLoading}
              recipData={docData} setDocData={setDocData} />
            {/* Buttons Row: Back | Save & Exit | Send Sleeves */}
            <div className="sleeve-step-buttons">
              <button className="sleeve-btn-back" onClick={onBack}>Back</button>
              <div>
                <button className="sleeve-btn-save" onClick={onSaveExit}>Save & Exit</button>
                <button className="sleeve-btn-next" onClick={handleSendSleeves} disabled={props.loading}>Send Sleeves</button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="sleeve-gradient-bg">
          <div className="sleeve-main-card">
            <div className="sleeve-title">Recipients</div>
            <div className="sleeve-subtitle">Add recipients and customize email details</div>

            {/* Recipient Details Card */}
            <div className="recipient-details-card-custom mb-4">
              <div className="recipient-details-card-custom-add">
                <div className="align-items-center gap-2">
                  <span className="fw-bold fs-5 Recipient Details">Recipient Details</span>
                  <i className="bi bi-info-circle ms-1 cur-pointer fs-5" aria-hidden="true" data-toggle="tooltip"
                    data-placement="left" title={"Add Recipient(s)\n\nEnter one or more email addresses of people from whom you need documents. Each will receive a personal link."} />
                </div>
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="step2-add-btn ms-auto"
                    data-bs-toggle="offcanvas"
                    ref={buttonRef}
                    data-bs-target="#addRecipients"
                    aria-controls="addRecipients"
                    data-toggle="tooltip"
                    title={Lang.env_add_recipient}
                  >
                    <span className="me-2">+</span>Add Recipients
                  </button>
                </div>
              </div>
              <div className="mb-3">
                <Select
                  classNamePrefix="sleeve-sender-select"
                  value={null}
                  inputValue={recipientSearch}
                  onInputChange={handleRecipientInputChange}
                  onFocus={handleRecipientInputFocus}
                  onChange={handleSelectRecipient}
                  options={recipientOptions}
                  placeholder="Search recipients..."
                  isClearable
                  isSearchable
                  formatOptionLabel={formatRecipientOption}
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: 8,
                      minHeight: 48,
                      borderColor: errors.recipient ? '#dc3545' : '#e3e8f0',
                      boxShadow: 'none',
                      background: '#fff'
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isFocused ? '#f3f4f6' : '#fff',
                      color: '#222',
                      cursor: 'pointer'
                    }),
                    menu: (base) => ({ ...base, zIndex: 99 }),
                    input: (base) => ({ ...base, fontSize: '1rem' }),
                  }}
                />
                {errors.recipient && (
                  <div className="text-danger mt-2">{errors.recipient}</div>
                )}
              </div>
              {/* Recipient List or Empty State */}
              {displayedRecipients.length === 0 ? (
                <div className="step2-empty-state">
                  <div className="icon"><i className="bi bi-people" /></div>
                  <div>No recipients added yet</div>
                  <div style={{ fontSize: '13px' }}>Click "Add Recipients" to get started</div>
                </div>
              ) : (
                <div className="gap-3 w-100">
                  {displayedRecipients.map((item, index) => (
                    <div className="recipient-list-item-custom d-flex align-items-center justify-content-between bg-white rounded-3 px-4 py-3 shadow-sm" key={index}>
                      <div className="d-flex align-items-center gap-3">
                        <div className="avatar-circle-custom">{item.first_name?.[0]?.toUpperCase() || ''}</div>
                        <div>
                          <div className="fw-bold recipient-name">{item.first_name + ' ' + item.last_name}</div>
                          <div className="recipient-email-mobile">
                            <span className="text-muted">{item.email}</span>
                            <span className="text-muted">{Utils.mobileFormat(item)}</span>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <span className="text-primary fs-5 cursor-pointer" onClick={(e) => onEditRecipient(e, item)}>
                          <i className="bi bi-pencil-square" />
                        </span>
                        <span className="text-danger fs-5 cur-pointer" onClick={(e) => onRemoveRecipient(e, index)}>
                          <i className="bi bi-x-lg" />
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Email Details Card */}
            <div className="step2-card step2-card-email sleeve-sender-card ">
              <div className="step2-section-title">
                <i className="bi bi-envelope-chec" />
                Email Details
              </div>
              <div className="mb-3">
                <label className="sleeve-step-label">Subject</label>
                <input
                  type="text"
                  className="sleeve-step-input"
                  value={subject}
                  onChange={e => handleEnvInput(e, 'subject')}
                  placeholder="Enter Email Subject"
                />
                {errors.subject && (
                  <div className="text-danger mt-1">{errors.subject}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="sleeve-step-label">Email Text</label>
                <textarea
                  className="sleeve-step-textarea"
                  rows={8}
                  value={emailText}
                  onChange={e => handleEnvInput(e, 'email_text')}
                  placeholder="Enter Email text box"
                />
                {errors.email_text && (
                  <div className="text-danger mt-1">{errors.email_text}</div>
                )}
              </div>
            </div>
            {/* Recipient Add/Edit Offcanvas */}
            <EnvelopeRecipients formObj={props.formObj} setFormObj={props.setFormObj} setLoading={props.setLoading}
              recipData={docData} setDocData={setDocData} />
            {/* Only for Normal Sleeve */}
            <div className="sleeve-step-buttons">
              <div>
                <button className="sleeve-btn-back" onClick={onBack}>
                  Back
                </button>
              </div>
              <div className="sleeve-step-buttons-right">
                <button className="sleeve-btn-save" onClick={onSaveExit}>
                  Save & Exit
                </button>
                <button className="sleeve-btn-next" onClick={onNext}>
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EnvelopeStep2;
